<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="contents"><a id="page_vii"></a>Contents</h2>
<p class="toc"><a class="nounder" href="#/Text/preface#preface">Preface</a></p>
<p class="toc"><a class="nounder" href="#/Text/ack#ack">Acknowledgments</a></p>
<p class="toc-part"><a class="nounder" href="#/Text/part01#part01">PART 1: THE PROBLEM</a></p>
<p class="toc-chap"><a class="nounder" href="#/Text/ch01#ch01"><em>Chapter 1</em> Time to Upgrade</a></p>
<p class="toc-chap"><span class="nounder" href="#/Text/ch02#ch02" title="Link target outside of Sample"><em>Chapter 2</em> A Short History of Capitalism</span></p>
<p class="toc-chap"><span class="nounder" href="#/Text/ch03#ch03" title="Link target outside of Sample"><em>Chapter 3</em> The Limits of Government</span></p>
<p class="toc-chap"><span class="nounder" href="#/Text/ch04#ch04" title="Link target outside of Sample"><em>Chapter 4</em> The Limits of Privatization</span></p>
<p class="toc-part"><span class="nounder" href="#/Text/part02#part02" title="Link target outside of Sample">PART 2: A SOLUTION</span></p>
<p class="toc-chap"><span class="nounder" href="#/Text/ch05#ch05" title="Link target outside of Sample"><em>Chapter 5</em> Reinventing the Commons</span></p>
<p class="toc-chap"><span class="nounder" href="#/Text/ch06#ch06" title="Link target outside of Sample"><em>Chapter 6</em> Trusteeship of Creation</span></p>
<p class="toc-chap"><span class="nounder" href="#/Text/ch07#ch07" title="Link target outside of Sample"><em>Chapter 7</em> Universal Birthrights</span></p>
<p class="toc-chap"><span class="nounder" href="#/Text/ch08#ch08" title="Link target outside of Sample"><em>Chapter 8</em> Sharing Culture</span></p>
<p class="toc-part"><span class="nounder" href="#/Text/part03#part03" title="Link target outside of Sample">PART 3: MAKING IT HAPPEN</span></p>
<p class="toc-chap"><span class="nounder" href="#/Text/ch09#ch09" title="Link target outside of Sample"><em>Chapter 9</em> Building the Commons Sector</span></p>
<p class="toc-chap"><span class="nounder" href="#/Text/ch10#ch10" title="Link target outside of Sample"><em>Chapter 10</em> What You Can Do</span></p>
<p class="toc1"><span class="nounder" href="#/Text/appendix#appendix" title="Link target outside of Sample">Appendix</span></p>
<p class="tocbm"><span class="nounder" href="#/Text/notes#notes" title="Link target outside of Sample">Notes</span></p>
<p class="tocbm"><span class="nounder" href="#/Text/resource#resource" title="Link target outside of Sample">Web Resource Guide</span></p>
<p class="tocbm"><span class="nounder" href="#/Text/bib#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="tocbm"><span class="nounder" href="#/Text/index#index" title="Link target outside of Sample">Index</span></p>
<p class="tocbm"><span class="nounder" href="#/Text/about#about" title="Link target outside of Sample">About the Author</span></p>
<p class="noindentt"><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1fb51caa